module.exports = __webpack_public_path__ + "media/images/official/event_bg_3-d356bdf6148356aa2d67112bc6a47f45.jpg";